import ScrollAnimation from '../../common/ScrollAnimation';
import Logo from '../logo/Logo';
import { siteContent } from '../../data/siteContent';

const callToActionData = {
  title: 'Ready to start creating a standard website?',
  subtitle:
    'If you have a product idea or an existing system that needs structure and reliability, I can help you ship the next version.',
  btnText: 'Contact Me',
};

const CalltoActionSeven = () => {
  return (
    <div className="rn-callto-action clltoaction-style-default style-7">
      <div className="container">
        <div className="row row--0 align-items-center content-wrapper">
          <div className="col-lg-8 col-md-8">
            <div className="inner">
              <div className="content text-left">
                <Logo
                  image={`${process.env.PUBLIC_URL}/images/logo/logo.png`}
                  image2={`${process.env.PUBLIC_URL}/images/logo/logo-dark.png`}
                />
                <p className="subtitle mt--30">{callToActionData.subtitle}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4">
            <ScrollAnimation
              animateIn="fadeInUp"
              animateOut="fadeInOut"
              animateOnce={true}
            >
              <div className="call-to-btn text-left mt_sm--20 text-md-right">
                <a
                  className="btn-default btn-icon"
                  href={siteContent.links.calendly}
                  target="_blank"
                  rel="noreferrer"
                >
                  {siteContent.cta.button.label}{' '}
                </a>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CalltoActionSeven;
